import axios from 'axios'
import { Loading } from 'element-ui';
import tool from './Tool.js'



let defaultTimeout = 10000  //默认请求时长
let loading =null;
/**
 * 请求拦截，加载Loading
 */
axios.interceptors.request.use(
    config => {
        loading = Loading.service({
            text:"加载中..."
        });
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);


/**
 * 响应拦截去除loading
 */
axios.interceptors.response.use(
    response => {
        loading.close();
        console.log('response ok');
        loadInterceptors(response); //加载拦截扩展
        return response;
    },
    error => {
        if(loading!==null){
            loading.close();
        }
        console.log(error);
        loadInterceptors(error.response); //加载拦截扩展
        console.log('response error');
    }
);

function loadInterceptors(response){
    const path = require("path");
    let files = require.context('@/tools/interceptors', false, /\.js$/);
    files.keys().forEach(filename=>{
        let tt = require('./interceptors/'+path.basename(filename));
        tt.default.intercept(response);
    });
}




/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Boolean} hasToken [请求头时是否需要带token]
 * @param {Object} config [axios请求配置]
 *
 */
export function get(url, params, hasToken= true,config={}){
    let headers = {}
    if(hasToken){
        headers.token = tool.getToken();
    }
    params = _transForm(params);
    let axiosConfig = {
        method:'get',
        url: process.env.VUE_APP_HOST + url + '?' + params,
        headers:headers,
        timeout: defaultTimeout // 请求超时时间
    }

    axiosConfig = Object.assign(axiosConfig,config)
    return new Promise((resolve, reject) =>{
        axios(axiosConfig).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err)
        })
    });
}


/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {Boolean} hasToken [请求头是否带token]
 * @param {String} contentType [请求头类型]
 * @param {Object} config [axios请求配置]
 */
export function post(url, params, hasToken = true, contentType=requestHeader.JSON ,config={}){
    let headers = {
        'Content-Type':contentType
    }
    if(hasToken){
        headers.token = tool.getToken();
    }
    if(contentType === requestHeader.WWW_FORM_URLENCODED){
        params = _transForm(params)
    }
    let axiosConfig = {
        method:'post',
        url: process.env.VUE_APP_HOST + url,
        data:params,
        headers:headers,
        timeout: defaultTimeout // 请求超时时间
    }
    //合并配置信息
    axiosConfig = Object.assign(axiosConfig,config)

    return new Promise((resolve, reject) =>{
        axios(axiosConfig).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err)
        })
    });
}

function _transForm(data){
    let ret = '';
    for(let it in data){
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret;
}

export let requestHeader = {
    WWW_FORM_URLENCODED:'application/x-www-form-urlencoded;charset=UTF-8',
    MULTIPART:'multipart/form-data',
    JSON:'application/json'
}

export default {

}
